// extracted by mini-css-extract-plugin
export default {"scLoading":"SCLoading_scLoading__9kdlF"};